/* eslint-disable import/no-extraneous-dependencies */

import $ from 'jquery';
import { mobileSummaryFloat } from './checkout/orderSummary';
import { debounce, processInclude } from './util';
import { MembershipTiles, equalizeTiles } from './membershipTilesSwiper';

window.$ = window.jQuery = $;

$(() => {
    const isAddressSuggestionEnabled = $('.js-personal-information-form').attr('data-suggestion-enabled') === 'true';

    processInclude(require('./checkout/subscriptionCheckout'));
    processInclude(require('./checkout/paymentScheduleUpdate'));
    processInclude(require('./checkout/couponHandler'));
    processInclude(require('./checkout/adyenHandler'));

    if (isAddressSuggestionEnabled) {
        processInclude(require('./checkout/addressAutocomplete'));
    }
    equalizeTiles();
});

let windowWidth = $(window).width();

$(window)
    .on('load', debounce(() => {
        mobileSummaryFloat();
    }, 300))
    .on('resize', () => {
        $(window).on('resize', debounce(() => {
            equalizeTiles();
        }, 300));

        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() !== windowWidth) {
            // Update the window width for next time
            windowWidth = $(window).width();
            if ($(window).width() < 768) {
                MembershipTiles.init();
            } else {
                MembershipTiles.destroy();
            }
        }
    });
